/*!
 * rolla.js - jQuery library for scrolling animations
 * @version v1.0.5
 * @date 2019-05-09
 * @author Miro Junker <miro.junker@gmail.com>
 *
 * Usage:
 *
 *  $(".animation_container").rolla([
 *    {
 *      selector: ".animation_figure",
 *      property: "height",
 *      unit: "px",
 *      start_value: 50,
 *      start_time: 0.25,
 *      move: 100,
 *      duration: 0.35
 *    },
 *    // another figure
 *  ]);
 */

$.fn.rolla = function (figures) {
  var container = this
  if (container.length) {
    var progress = 0,
      sceneHeight,
      beginEdge,
      endEdge,
      viewportHeight,
      duration

    var initEdges = function () {
      sceneHeight = container.outerHeight()
      beginEdge = container.offset().top
      endEdge = beginEdge + sceneHeight
      viewportHeight = $(window).outerHeight()
      duration = viewportHeight + sceneHeight
    }

    var style = function (fig) {
      // calculate timing for particular animation
      var time = (progress - fig.start_time) / fig.duration
      if (time < 0) time = 0
      else if (time > 1) time = 1
      else time = easeInOutQuad(time)
      // calculate actual value
      var value = time * fig.move + fig.start_value + fig.unit
      $(fig.selector).css(fig.property, value)
    }

    var easeInOutQuad = function (t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
    }

    var render = function () {
      figures.forEach(function (figure) {
        style(figure)
      })
    }

    function updateProgress() {
      viewportBegin = $(window).scrollTop()
      viewportEnd = viewportBegin + viewportHeight
      if (viewportEnd < beginEdge) {
        // under the viewport =  before animation
        progress = 0
      } else if (viewportBegin > endEdge) {
        // over the viewport = after animation
        progress = 1
      } else {
        // animation in progress
        progress = (viewportEnd - beginEdge) / duration
      }
      render()
    }

    $(window).on('load', function () {
      initEdges()
      //updateProgress()
    })

    $(window).resize(initEdges)
    //$(window).scroll(updateProgress)

    function repeat() {
      updateProgress()
      requestAnimationFrame(repeat)
    }
    requestAnimationFrame(repeat)

    initEdges()
    //updateProgress()
  }
};
